import React from "react";
import classNames from 'classnames';
import Modal from "react-bootstrap/lib/Modal";

export default class MywortModalWrapper extends React.Component {

    get className() {
        return classNames(this.props.className, 'mywort-modal');
    }

    render() {
        return (
            <Modal {...this.props} className={this.className} >
                {this.props.children}
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./js/mywort/commons/components/MywortModalWrapper.jsx